import { KycStatus } from '../models/dtos/kyc';

// Partner-agnostic KYC gate (epic b.ii.2 OQ #2). The KYC form is shown when
// the borrower's KYC status is NotStarted or Expired; every other status
// (Approved, Completed, InProgress, etc.) skips the form. This is keyed off the
// KYC status only — not off loanPartnerId — so Unobank (a.i.2) can reuse it.
export function isKycFormRequired(status: KycStatus | null | undefined): boolean {
  return status === KycStatus.NotStarted || status === KycStatus.Expired;
}
